const Theme = {
    body_background_color: '#ebe4d9',
    card_background_color: '#fff',
    logo_height: 140,
    logo_image_url:'experiencepotton.svg',

   

    token_url: 'experiencepotton.jpg',
   
    number_size: 20,
    number_color: '#fff',
    number_top: 25,

    button_radius: 15,
    button_border_width:1,
    button_color: '#004b87',
    button_outlined_color: 'white',
    button_text_color: 'white',

    button_half_text_color: '#004b87',
    button_half_border_color: '#004b87',

    text_font: 'montserrat',
    text_color: 'black',

    title_font: 'montserrat',
    subtitle_font: 'montserrat',
    
    title_weight: 600,
    subtitle_weight: 500,
    input_text_weight: 400,
    button_text_weight: 500,

}

export default Theme
